import React, { useContext, useState } from "react";
import Heading_banner_section from "../../common_components/heading_banner/Heading_banner_section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Context } from "../../../utils/context";
import { Controller, useForm } from "react-hook-form";
import {
  changeContact,
  changeEmail,
} from "../../../utils/apis/myAccount/myAccount";
import { RegxExpression } from "../../../utils/common";
import LogoutModal from "../../../components/Common-Component/Commonmodal/LogoutModal/LogoutModal";

function Update_contact_number() {
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "YOUR ACCOUNT", link: "/luxury/account" },
    { label: "Update Contact Number" },
  ];
  const { userdata, setSignin } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
    setValue,
  } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("contact_no", data?.contact_no);
    formData.append("password", data?.password);

    const res = await changeContact(formData);
    if (res?.success) {
      navigate("/luxury/account");
    } else {
      if (res?.message?.email) {
        setError("contact_no", { message: res?.message?.contact_no });
      } else if (res?.message?.password) {
        setError("password", { message: res?.message?.password });
      }
    }
  };
  const [logoutshow, setLogoutshow] = useState(false);
  return (
    <>
      <section className="All_Orders Communication_preferences Manage_address Manage_address_form">
        <Heading_banner_section
          headingText={`${userdata?.first_name} ${userdata?.last_name}`}
          breadcrumbItems={breadcrumbItems}
        />

        <div className="custom_container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="all_order_section_holder">
                <div className="text_holder">
                  <h3
                    className="sign_out_text"
                    onClick={() => setLogoutshow(true)}
                  >
                    <FontAwesomeIcon
                      className="me-3"
                      icon={faArrowRightFromBracket}
                    />
                    SIGN OUT
                  </h3>
                </div>

                <div className="heading_tab_content_holder">
                  <div className="heading_holder">
                    <h1>UPDATE CONTACT NUMBER</h1>
                    <p>
                      This contact number will be updated in our records for all
                      future communication and for orders and account security.
                      It will not be shared with third parties.
                    </p>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <div className="content_box_holder">
                      <Form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                          <div className="col-md-12">
                            <Form.Group className="mb-3">
                              <Form.Label>Add Contact Number</Form.Label>
                              <Controller
                                name="contact_no"
                                control={control}
                                rules={{
                                  validate: (value) =>
                                    value || getValues("email")
                                      ? true
                                      : "Mobile Number or Email is required",
                                  pattern: {
                                    value: /^\+?\d{1,4}[-\s]?\d{10}$/,
                                    message:
                                      "Invalid number format. Please enter a valid number with an optional country code",
                                  },
                                }}
                                render={({ field }) => (
                                  <PhoneInput
                                    country={"in"}
                                    {...field}
                                    onChange={(value) => field.onChange(value)}
                                    type="text"
                                    placeholder="Enter Mobile Number"
                                    onKeyDown={(event) => {
                                      if (
                                        !RegxExpression.phone.test(event.key)
                                      ) {
                                        if (event.key !== "Backspace") {
                                          event.preventDefault();
                                        }
                                      }
                                    }}
                                    maxLength={10}
                                  />
                                )}
                              />
                              {errors?.contact_no && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors?.contact_no?.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-12">
                            <Form.Group className="mb-3">
                              <Form.Label>Enter Password To Save</Form.Label>
                              <Form.Control
                                type="text"
                                name="m_name"
                                placeholder="Enter Password"
                                {...register("password", {
                                  required: "Password required",
                                })}
                              />
                              {errors.password && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.password.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>
                        </div>

                        <div className="btn_holder">
                          <div>
                            <Purple_Btn
                              btnText="Update"
                              type="submit"
                              // onClick={() => navigate("/luxury/account")}
                            />
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LogoutModal
          show={logoutshow}
          onHide={() => setLogoutshow(false)}
          text="Are you sure you want to log out?"
          setSignin={setSignin}
        />
      </section>
    </>
  );
}

export default Update_contact_number;
